import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppProviders } from './app/providers';
import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import './styles/tailwind.css';
import './utils/debugAuth'; // Debug utilities available in console

// Initialize monitoring
initSentry();
initAnalytics();

// Log debug info in development
if (import.meta.env.DEV) {
  console.log('🔧 Debug mode enabled. Use window.debugAuth() to check auth state');
}

// Register service worker for push notifications and PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });

      console.log('✅ Service Worker registered successfully');

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available, reload to update
              console.log('🔄 New version available. Reloading...');
              window.location.reload();
            }
          });
        }
      });

      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'NOTIFICATION_CLICKED') {
          // Navigate to the URL from notification
          window.location.href = event.data.url;
        }
      });
    } catch (error) {
      console.error('❌ Service Worker registration failed:', error);
    }
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>
);